import { Button, CircularProgress, IconButton, InputAdornment, TextField, Theme, createStyles } from "@mui/material";
import { DrawerContainer } from "../../shared/drawer/DrawerContainer";
import { makeStyles } from '@mui/styles';
import { useEffect, useState } from "react";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import * as solace from 'solclientjs';
import { setDisconnected, setConnected } from "../../../redux/actions/connectionActions";
import { useDispatch, useSelector } from "react-redux";
import { STORE_SOLACE_CREDENTIALS } from '../../../redux/actions/storeSolaceCredentialsActions';
import { STORE_BROKER_FIELD_DETAILS } from '../../../redux/actions/storeBrokerFieldDetailsActions';
import { getBrokerFieldDetailSelector } from '../../../redux/selectors/getBrokerFIeldDetailSelector';
import { ToolBarContainer } from "../../shared/toolbar/ToolBarContainer";

const useStyles: any = makeStyles((theme: Theme) => ({
  // root: {
  //   margin: 0,
  // },
  mainContainer: {
    boxSizing: 'border-box',
    width: '100%',
    padding: '0 0 0 65px',
    height: '100%'
  },
  table: {
    minWidth: 650,
    // minHeight: 500,
    maxHeight: 500,
    marginTop: '0.5rem'
  },
  emptyRowMessage: {
    margin: '0 auto',
    padding: '2rem'
  },
  buttons: {
    // width: '8%',
    color: 'black',
    borderRadius: '5px',
    background: '#b9b9b9',
    textTransform: 'none',
    fontSize: '20px',
    '&:hover': {
      background: '#787878',
    },
    height: '3.2rem',
  },
  input: {
    color: '#000000',
    // width: 200,
    height: 50,
    width: '100%',
  },
  inputHalfWidth: {
    width: '50%',
    '& .MuiAutocomplete-inputRoot': {
      height: 50,
    },
    margin: '10px 0 !important',
  },
  cardSubForm: {
    '& .MuiCardHeader-root': {
      paddingBottom: '0',
    },
    '& .MuiCardContent-root': {
      padding: '16px',
    },
  },
  buttonConfig: {
    margin: '2rem 0 !important'
  },
  dbIcon: {
    width: '25px',
    height: '25px',
  }
}))

export const BrokerComponent = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const fieldDetail : any = useSelector(getBrokerFieldDetailSelector);
  const [showPassword, setShowPassword] = useState(false);

  const handleSetDisconnected = () => {
    dispatch(setDisconnected());
  };

  const handleSetConnected = () => {
    dispatch(setConnected());
  };

  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  }

  const handleMouseDownPassword = (event: any) => {
    event.preventDefault()
  }

  const handleFormChange = (fieldName: string, e: any) => {

    dispatch({
      type : STORE_BROKER_FIELD_DETAILS,
      payload : { key : fieldName, value : e.target.value}
    });
   
  }

  const handleAddBroker = (e: any) => {
    // handleSetDisconnected();
    connectBroker(fieldDetail);
    dispatch({ type: STORE_SOLACE_CREDENTIALS, payload: fieldDetail });
  }

  const QueueBrowser = (solaceModule: any, queueName: any, uniqueId: any, fieldDetail: any) => {
    let solace = solaceModule
    let resultArray = [1, 2];

    var consumer: any = {
      session: null,
      queueName: queueName,
      consuming: false,
      messageConsumer: null,
      log(line: any) { },
      run() { },
      connect() { },
      startConsume() { },
      exit() { },
      stopConsume() { },
      disconnect() { },
    };

    consumer.run = () => {
      console.log('\n*** browser to queue "' + consumer.queueName + '" is ready to connect ***')
      consumer.connect();
    };

    consumer.connect = (currentHost: any) => {
      if (consumer.session !== null) {
        console.log('Already connected and ready to consume messages.');

        return;
      }


      const hosturls = fieldDetail['host'];
      // const hosturls = ['wss://mr-connection-cgqe4yfft1l.messaging.solace.cloud:443'];
      console.log('Connecting to Solace message router using url: ' + JSON.stringify(hosturls));

      // var username = 'solace-cloud-client';
      var username = fieldDetail['clientUsername'];
      console.log('Client username: ' + username);

      // var vpn = 'testing';
      var vpn = fieldDetail['messageVpn'];
      console.log('Solace message router VPN name: ' + vpn);

      // var pass = '3tuiorup39tbuv0egibqthibgc';
      var pass = fieldDetail['clientPassword'];
      console.log(`Client password: - ${pass} `);


      if (!hosturls || !username || !vpn || !pass) {
        return;
      }

      // create session
      try {
        consumer.session = solace.SolclientFactory.createSession({
          // solace.SessionProperties
          url: hosturls,
          vpnName: vpn,
          userName: username,
          password: pass,
          connectRetries: 3,
          connectRetriesPerHost: 3,
          reconnectRetries: -1
        });
      } catch (error) {
        console.log(`Unable to establish session to Solace message router for queue ${consumer.queueName}, Exception : ${error}`);
      }

      // define session event listeners
      consumer.session.on(solace.SessionEventCode.UP_NOTICE, function (sessionEvent: any) {
        console.log(`Successfully connected to and ready to start the message consumer for queue ${consumer.queueName}`);

        // const connectionStatus: any = document.querySelector('.connection-status');
        // connectionStatus.classList.add('connected');

        handleSetConnected();
      });
      consumer.session.on(solace.SessionEventCode.CONNECT_FAILED_ERROR, function (sessionEvent: any) {
        console.log(`Connection failed to the Solace message router for queue ${consumer.queueName}, Exception :  ${sessionEvent.infoStr} - check correct parameter values and connectivity!`);


        // const connectionStatus: any = document.querySelector('.connection-status');
        // connectionStatus.classList.remove('connected');
        handleSetDisconnected();
      });
      consumer.session.on(solace.SessionEventCode.DOWN_ERROR, function (sessionEvent: any) {
        console.log(`Connection failed to the Solace message router for queue ${consumer.queueName}, Exception :  ${sessionEvent.infoStr} - check correct parameter values and connectivity!`);
        handleSetDisconnected();
      });
      consumer.session.on(solace.SessionEventCode.DISCONNECTED, function (sessionEvent: any) {
        console.log(`Queue consumer for queue ${consumer.queueName} got disconnected`);
        consumer.consuming = false;
        if (consumer.session !== null) {
          consumer.session.dispose();
          consumer.session = null;
        }
      });

      try {
        consumer.session.connect();
      } catch (error) {
        console.log(`An Unexpected error connecting to Solace message router for queue ${consumer.queueName}, Exception: ${error}`);
      }

    };

    resultArray[1] = consumer;
    return resultArray;
  }

  const connectBroker = (fieldDetail: any) => {
    const factoryProps = new solace.SolclientFactoryProperties();
    factoryProps.profile = solace.SolclientFactoryProfiles.version10;
    solace.SolclientFactory.init(factoryProps);

    // enable logging to JavaScript console at WARN level
    // NOTICE: works only with ('solclientjs').debug
    solace.SolclientFactory.setLogLevel(solace.LogLevel.WARN);

    // create the consumer, specifying the name of the queue
    let resultArray: Array<any> = QueueBrowser(solace, '', '', fieldDetail);

    const consumer = resultArray[1]
    // console.log(`Queue consumer initialized for queue ${queueName}`);

    // create the consumer, specifying the name of the queue
    // let resultArray = QueueBrowser(solace, queueName, uniqueId);
    consumer.run();

    // wait to be told to exit
    // consumer.log("Press Ctrl-C to exit");
    // process.stdin.resume();

    // process.on('SIGINT', function () {
    //     'use strict';
    //     consumer.exit();
    // });

    return resultArray;
  }

  return (
    <div className={classes.root}>
      <ToolBarContainer title={'Broker Connection Details'} />
      <form
        onSubmit={(e) => {
          e.preventDefault();
        }}
        style={{
          padding: '0 20px',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <TextField
          label={'Host'}
          name={'host'}
          placeholder={'Host'}
          type='text'
          value={
            fieldDetail['host'] &&
              fieldDetail['host'] ?
              fieldDetail['host'] : ''
          }
          onChange={(e: any) => {
            handleFormChange('host', e)
          }}
          className={
            classes.inputHalfWidth
          }
          InputProps={{
            className: classes.input,
          }}
          variant='outlined'
          required={true}
        />
        <TextField
          label={'Message Vpn'}
          name={'messageVpn'}
          placeholder={'Message Vpn'}
          type='text'
          value={
            fieldDetail['messageVpn'] &&
              fieldDetail['messageVpn'] ?
              fieldDetail['messageVpn'] : ''
          }
          onChange={(e: any) => {
            handleFormChange('messageVpn', e)
          }}
          className={
            classes.inputHalfWidth
          }
          InputProps={{
            className: classes.input,
          }}
          variant='outlined'
          required={true}
        />
        <TextField
          label={'Client Username'}
          name={'clientUsername'}
          placeholder={'Client Username'}
          type='text'
          value={
            fieldDetail['clientUsername'] &&
              fieldDetail['clientUsername'] ?
              fieldDetail['clientUsername'] : ''
          }
          onChange={(e: any) => {
            handleFormChange('clientUsername', e)
          }}
          className={
            classes.inputHalfWidth
          }
          InputProps={{
            className: classes.input,
          }}
          inputProps={{
            autocomplete: 'new-password',
            form: {
              autocomplete: 'off',
            },
          }}
          variant='outlined'
          required={true}
        />
        <TextField
          label={'Client Password'}
          name={'clientPassword'}
          placeholder={'Client Password'}
          type={showPassword ? 'text' : 'password'}
          value={
            fieldDetail['clientPassword'] &&
              fieldDetail['clientPassword'] ?
              fieldDetail['clientPassword'] : ''
          }
          onChange={(e: any) => {
            handleFormChange('clientPassword', e)
          }}
          className={
            classes.inputHalfWidth
          }
          InputProps={{
            className: classes.input,
            endAdornment:
              (
                <InputAdornment position="end">
                  <IconButton
                    onClick={
                      handleClickShowPassword
                    }
                    onMouseDown={
                      handleMouseDownPassword
                    }
                  >
                    {showPassword ? (
                      <Visibility />
                    ) : (
                      <VisibilityOff />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
          }}
          inputProps={{
            autocomplete: 'new-password',
            form: {
              autocomplete: 'off',
            },
          }}
          variant='outlined'
          required={true}
        />
        <div>
          <Button
            type='submit'
            onClick={(e) => {
              handleAddBroker(e);
            }}
            variant="contained"
            color="primary"
            size="large"
            disabled={false}
            className={
              classes.buttonConfig
            }
            endIcon={
              false ? (
                <CircularProgress
                  style={{
                    color: 'white',
                    height: '23px',
                    width: '23px',
                    margin: '0 6px 0 0',
                  }}
                />
              ) : (
                ''
              )
            }
          >
            Connect
          </Button>
        </div>
      </form>
    </div>
  );
}